import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Tippy } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

function DependantFieldCell({ cell }) {
  const { value = null, iconSize = 'md' } = cell;
  const parentField = cell?.row?.original?.parentField?.label || null;
  const intl = useIntl();
  return (
    <div className="flex-center">
      {value ? (
        <>
          <Tippy
            className="flex-imp"
            title={`${getTranslatedText(
              intl,
              'common.admin.dependent.to'
            )} ${parentField || value}`}
            interactive
            arrow={false}
            theme="dark"
            appendTo={document.body}
            position="bottom"
          >
            <SVGIcon name="DependentField" size={iconSize} />
          </Tippy>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default DependantFieldCell;
